(function () {
  "use strict";
  if (window.SAESizeButtons) { window.SAESizeButtons.initialize(); return; }
  var bound = new WeakSet();

  function initialize() {
    document.querySelectorAll("form[data-sae-size-buttons]").forEach(function (form) {
      if (form.dataset.saeSizeButtons === "false" || bound.has(form)) return;
      var source = form.querySelector('[data-type="product-variations-data"]');
      var field = form.querySelector('[name="id"]');
      var selects = Array.from(form.querySelectorAll('select[data-node-type="add-to-cart-option-select"]'));
      var variants;
      try { variants = JSON.parse(source.textContent); } catch (_) { return; }
      if (!field || !selects.length || !Array.isArray(variants) || !variants.length) return;
      if (selects.some(function (select) { return !select.closest("fieldset"); })) return;
      bound.add(form);
      form.classList.add("sae-purchase-controls");
      var groups = selects.map(function (select, index) {
        var host = select.closest("fieldset");
        var legend = document.createElement("legend");
        var label = host.dataset.saeOptionLabel || (selects.length === 1 ? "Size" : "Option " + (index + 1));
        var group = document.createElement("div");
        group.className = "sae-option-buttons";
        legend.className = "sae-option-legend";
        host.insertBefore(legend, host.firstChild);
        host.appendChild(group);
        var buttons = Array.from(select.options).filter(function (option) { return option.value !== ""; }).map(function (option) {
          var button = document.createElement("button");
          button.type = "button";
          button.className = "sae-purchase-button";
          button.textContent = option.textContent;
          button.dataset.value = option.value;
          button.addEventListener("click", function () {
            // Keep earlier choices. Retain later choices when that combination is in stock.
            var candidates = variants.filter(function (variant) {
              return variant.available && variant[select.name] === option.value && selects.slice(0, index).every(function (earlier) {
                return variant[earlier.name] === earlier.value;
              });
            });
            var variant = candidates.find(function (candidate) {
              return selects.slice(index + 1).every(function (later) { return candidate[later.name] === later.value; });
            }) || candidates[0];
            if (!variant) return;
            selects.forEach(function (control) { control.value = variant[control.name]; });
            // The original theme owns variant IDs, prices, images, inventory, and checkout.
            select.dispatchEvent(new Event("change", { bubbles: true }));
            sync();
          });
          group.appendChild(button);
          return button;
        });
        return { select: select, legend: legend, label: label, buttons: buttons };
      });

      function sync() {
        groups.forEach(function (group, index) {
          var selected = Array.from(group.select.options).find(function (option) { return option.value === group.select.value; });
          group.legend.textContent = group.label + (selected ? ": " + selected.textContent : "");
          group.buttons.forEach(function (button) {
            var available = variants.some(function (variant) {
              return variant.available && variant[group.select.name] === button.dataset.value && selects.slice(0, index).every(function (earlier) {
                return variant[earlier.name] === earlier.value;
              });
            });
            button.disabled = !available;
            button.setAttribute("aria-pressed", String(button.dataset.value === group.select.value));
            button.setAttribute("aria-label", group.label + ": " + button.textContent + (available ? "" : " — unavailable"));
          });
        });
      }
      form.dataset.saeButtonsReady = "true";
      form.addEventListener("change", function () { requestAnimationFrame(sync); });
      form.addEventListener("variation_found", sync);
      sync();
    });
  }
  window.SAESizeButtons = { initialize: initialize };
  initialize();
  document.addEventListener("DOMContentLoaded", initialize, { once: true });
  document.addEventListener("shopify:section:load", initialize);
})();
